import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  Badge,
} from "reactstrap";
import { FaBalanceScale, FaUserTie, FaHandshake, FaLaptop } from "react-icons/fa";
import WhiteNavbar from "components/Navbars/WhiteNavbar";
import Footer from "components/Footers/Footer";
import PictureHeader from "components/PictureHeader/PictureHeader";
import imageHeader from "../assets/ossaPictures/newHeader.png";
import tech from "../assets/ossaPictures/technology.png";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <>
      <Helmet>
        <title>HAKKIMIZDA | ARS HUKUK</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="ARS Hukuk Bürosu: Uzman hukuk danışmanlık hizmetleri."
          data-rh="true"
        />
        <link
          rel="canonical"
          href="https://www.arshukukburosu.com/hakkimizda"
        />
        <meta property="og:title" content="HAKKIMIZDA | ARS HUKUK" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Uzman kadromuz ile hukuki sorunlarınıza çözümler sunuyoruz."
        />
        <meta property="og:image" content="../assets/ossaPictures/newHeader.jpeg" />
        <meta
          property="og:url"
          content="https://www.arshukukburosu.com/hakkimizda"
        />
      </Helmet>
      <WhiteNavbar navbarSelection={"about-us"} />
      <PictureHeader imageHeader={imageHeader} />

      <div className="about-us-section">
        <Container>
          {/* Section: Introduction */}
          <Row className="mt-5">
            <Col md="12" className="text-center" data-aos="fade-up">
              <h1 className="display-4">Hakkımızda</h1>
              <p className="lead">
                ARS Hukuk Bürosu, müvekkillerine yenilikçi ve etkin hukuk çözümleri
                sunmayı amaçlayan bir hukuk danışmanlık firmasıdır.
              </p>
            </Col>
          </Row>

          {/* Section: Our Mission */}
          <Row className="mt-5">
            <Col md="6" data-aos="fade-right">
              <Card className="shadow-sm">
                <CardBody>
                  <CardTitle tag="h3" className="text-primary mb-4">
                    Misyonumuz
                  </CardTitle>
                  <p>
                    ARS Hukuk Bürosu olarak, müvekkillerimizin haklarını en iyi şekilde
                    savunmak ve hukuki süreçlerde profesyonel çözümler sunmak
                    öncelikli hedefimizdir. Ticaret, aile, ceza ve sigorta hukuku gibi
                    geniş bir yelpazede uzmanlaşmış ekibimizle yanınızdayız.
                  </p>
                </CardBody>
              </Card>
            </Col>
            <Col md="6" data-aos="fade-left">
              <Card className="shadow-sm">
                <CardBody>
                  <CardTitle tag="h3" className="text-primary mb-4">
                    Vizyonumuz
                  </CardTitle>
                  <p>
                    Hukuk sektöründe lider ve güvenilir bir isim olarak, dünya
                    standartlarında hizmet sunmayı amaçlıyoruz. Teknoloji destekli
                    çözümlerimiz ve müvekkil odaklı yaklaşımımızla sektörde fark
                    yaratıyoruz.
                  </p>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Section: Our Values */}
          <Row className="mt-5">
            <Col md="4" data-aos="zoom-in">
              <Card className="text-center shadow-sm">
                <CardBody>
                  <FaBalanceScale size={50} className="text-primary mb-3" />
                  <CardTitle tag="h4">Adalet ve Güven</CardTitle>
                  <p>
                    Hukukun üstünlüğünü esas alarak müvekkillerimizin haklarını
                    savunuyoruz.
                  </p>
                </CardBody>
              </Card>
            </Col>
            <Col md="4" data-aos="zoom-in">
              <Card className="text-center shadow-sm">
                <CardBody>
                  <FaUserTie size={50} className="text-primary mb-3" />
                  <CardTitle tag="h4">Uzman Kadro</CardTitle>
                  <p>
                    Alanında deneyimli avukatlardan oluşan ekibimizle size en iyi
                    hizmeti sunuyoruz.
                  </p>
                </CardBody>
              </Card>
            </Col>
            <Col md="4" data-aos="zoom-in">
              <Card className="text-center shadow-sm">
                <CardBody>
                  <FaHandshake size={50} className="text-primary mb-3" />
                  <CardTitle tag="h4">Müvekkil Odaklı Yaklaşım</CardTitle>
                  <p>
                    Müvekkillerimizin ihtiyaçlarını dinliyor ve onlara özel çözümler
                    sunuyoruz.
                  </p>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Section: Technology */}
          <Row className="mt-5">
            <Col md="6" data-aos="fade-right">
              <h3 className="text-primary">Modern Altyapı</h3>
              <p>
                ARS Hukuk Bürosu olarak, IT destekli hukuki altyapımızla süreçleri
                hızlandırıyor ve müvekkillerimize kesintisiz destek sağlıyoruz. Hukuki
                süreçleri daha erişilebilir hale getirmek için dijital çözümler
                sunuyoruz.
              </p>
            </Col>
            <Col md="6" data-aos="fade-left">
              <img
                src={tech}
                alt="Modern Infrastructure"
                className="img-fluid rounded"
              />
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default AboutUs;